import { Component }       from '@angular/core';
import { ActivatedRoute }  from '@angular/router';
import { Location }        from '@angular/common';
import { AdminService } from '../../services/admins/admin.service';
import { UserDetailComponent } from '../../users/detail/user-detail.component';
import * as _ from 'lodash';
import { Auth } from '../../services/auth.service';

@Component({
  moduleId: module.id,
  selector: 'my-admin-detail',
  templateUrl: 'admin-detail.component.html',
  styleUrls: [ '../../users/detail/user-detail.component.css' ]
})

export class AdminDetailComponent extends UserDetailComponent {

  constructor(
    protected adminService: AdminService,
    protected route: ActivatedRoute,
    protected location: Location,
    protected auth: Auth
  ) { super(adminService, route, location); }

  user;
  permissions = [];
  adminPermissions = [];
  adminNotPermissions = [];
  permissionsChanged = false;
  hasBOUsersPermission:Boolean = false;

  protected getDefaultUserImageUrl(): string {

    return 'http://www.arcadegrab.com/uploads/avatars/user-1.png';
  };

  async fillObject(){
    this.hasBOUsersPermission = this.auth.hasBOUsersPermission();
    var permissions = await this.adminService.getPermissions()
    permissions.forEach(permission => {
      if (this.updatedUser.permissions.includes(permission.id)){
        this.adminPermissions.push(permission)
      } else {
        this.adminNotPermissions.push(permission)
      }
    })
  }
  addPermission(permissionToAdd){
    this.updatedUser.permissions.push(permissionToAdd.id);
    this.adminPermissions.push(permissionToAdd);
    this.adminNotPermissions = this.adminNotPermissions.filter(permission => permission.id != permissionToAdd.id);
    this.permissionsChanged = true;
  }

  removePermission(permissionToRemove){
    this.updatedUser.permissions = this.updatedUser.permissions.filter(permission => permission != permissionToRemove.id);
    this.adminNotPermissions.push(permissionToRemove);
    this.adminPermissions = this.adminPermissions.filter(permission => permission.id != permissionToRemove.id);
    this.permissionsChanged = true;
  }

  protected getUpdatedFields(): any {
    let updatedFields = {};
    let self = this;
    _.each(self.updatedUser, function (value: any, key: string) {
      if ((key=='permissions' && self.permissionsChanged) || self.user[key] !== value){
        updatedFields[key] = value;
      }
    });
    return updatedFields;
  }
}



// WEBPACK FOOTER //
// ./src/app/admins/detail/admin-detail.component.ts